import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";
import { TextOne, TextThree, TextTwo } from "../../policyText";

// Others File

const Policy = () => {
  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="rules" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">
          شرایط و قوانین استفاده از خدمات اپلیکیشن و وب‌سایت رفاپ
        </p>
        <div className="border rounded-lg mt-8 border-mygray-300 px-4">
          <p className="text-sm md:text-base font-bold text-mygray-700 mb-2 mt-4">
            ماده ۱ - تعاریف و اصطلاحات
          </p>
          <div className="text-sm md:text-base text-mygray-500">
            <TextOne />
          </div>
          <p className="text-sm md:text-base font-bold text-mygray-700 mb-2 mt-4">
            ماده ۲ - حساب کاربری
          </p>
          <div className="text-sm md:text-base text-mygray-500">
            <TextTwo />
          </div>
          <p className="text-sm md:text-base font-bold text-mygray-700 mb-2 mt-4">
            ماده ۳ - استفاده از رفاپ
          </p>
          <div className="text-sm md:text-base text-mygray-500">
            <TextThree />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Policy;
